import { useEffect, useState } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import styles from './PwaUpdater.module.css';

export const PwaUpdater = () => {
  const [open, setOpen] = useState(false);
  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    immediate: true,
    onRegisteredSW(swUrl, registration) {
      // eslint-disable-next-line no-console
      console.info('Service worker registered:', swUrl);
      // Kick off an update check on app start so we surface refresh prompts promptly.
      if (registration) {
        registration.update().catch(() => {
          // Best-effort update; swallow errors to avoid noisy logs.
        });
      }
    },
    onRegisterError(error) {
      // eslint-disable-next-line no-console
      console.error('Service worker registration failed', error);
    },
  });

  useEffect(() => {
    if (offlineReady || needRefresh) {
      setOpen(true);
    }
  }, [offlineReady, needRefresh]);

  const close = () => {
    setOfflineReady(false);
    setNeedRefresh(false);
    setOpen(false);
  };

  const onUpdate = () => updateServiceWorker(true);

  if (!open) {
    return null;
  }

  return (
    <div className={styles.banner} role="status" aria-live="polite">
      <div className={styles.text}>
        {offlineReady && <span>AwkHerd is ready to work offline.</span>}
        {needRefresh && <span>A new version is available.</span>}
      </div>
      <div className={styles.actions}>
        {needRefresh && (
          <button type="button" className={styles.primary} onClick={onUpdate}>
            Reload to update
          </button>
        )}
        <button type="button" className={styles.secondary} onClick={close}>
          Dismiss
        </button>
      </div>
    </div>
  );
};
